'use strict';

module.exports = {
    updateAttributes: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.main-content-group .product-attributes')
                .empty()
                .html(data.attributesHtml);

            $('body').trigger('tooltip:init');
            if ($('button.add-to-cart-global').length) {
                module.exports.updateAddAllToCart();
            }
        });
    },
    updateHeadlinesAndTabs: function () {
        $('body').on('product:afterAttributeSelect', function (e, data) {
            if (data && data.data && data.data.product && data.container) {
                var $productContainer = data.container;
                var product = data.data.product;

                if (product.headline) {
                    $productContainer.find('.product-headline')
                        .show()
                        .html(product.headline);
                } else {
                    $productContainer.find('.product-headline')
                        .hide();
                }

                if (product.headlineDescription) {
                    $productContainer.find('.product-headlinedescription')
                        .show()
                        .html(product.headlineDescription);
                } else {
                    $productContainer.find('.product-headlinedescription')
                        .hide();
                }
            }
        });
    },
    updateCollapsibleContent: function () {
        $('body').on('product:afterAttributeContentSwap', function (e, data) {
            module.exports.setCollapsibleContentState((data && data.container) ? data.container : '');
        });
    },
    updateAddAllToCart: function () {
        // if default variants are selected, enable the add all to cart btn on load
        if ($('button.add-to-cart-global').length) {
            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            $('button.add-to-cart-global').attr('disabled', !enable);
        }
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },
    showSpinner: function () {
        $('body').on('product:beforeAddToCart, product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    setCollapsibleContentState: function ($container) {
        var $collapsibleContentGroup;

        if ($container) {
            $collapsibleContentGroup = $container.find('.collapsible-content-group');
        } else {
            $collapsibleContentGroup = $('.collapsible-content-group');
        }

        $collapsibleContentGroup.each(function () {
            var expandCollapsibleContentGroup = $(this).data('expand');
            if (expandCollapsibleContentGroup == true) {
                $(this).addClass('active');
            }
        });
    }
};


(function () {

    const container = document.querySelector('[data-component="pdScrollTabs"]');
    if (!container) return;

    const tabs = container.querySelectorAll('.pd-tab');
    const sections = container.querySelectorAll('.pd-section');

    /* CLICK → SCROLL */
    tabs.forEach(tab => {

        tab.addEventListener('click', () => {

            const targetId = tab.dataset.target;
            const target = document.getElementById(targetId);

            window.scrollTo({
                top: target.offsetTop - 80, // adjust for sticky nav
                behavior: 'smooth'
            });

        });

    });

    /* SCROLL → ACTIVE TAB */
    window.addEventListener('scroll', () => {

        let current = "";

        sections.forEach(section => {
            const sectionTop = section.offsetTop - 100;

            if (window.scrollY >= sectionTop) {
                current = section.getAttribute('id');
            }
        });

        tabs.forEach(tab => {
            tab.classList.remove('active');

            if (tab.dataset.target === current) {
                tab.classList.add('active');
            }
        });

    });

})();
$(document).ready(function () {
     const offerHeader = document.querySelector(
        ".offer-header.js-offers-toggle.d-flex.align-items-center"
        );
        if (offerHeader && offerHeader.classList.contains("offer-promo")) {
        $('.offer-body').hide();
        }

    $('.js-offers-toggle').on('click', function (e) {

        // tooltip click ignore
        if ($(e.target).closest('.tooltip-icon').length) {
            return;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        const $promo = $(this).closest('.offer-promo');
        const $body = $promo.find('.offer-body');
        $body.stop(true, true).slideToggle(300);
        $(this).find('.custom-arrow-icon').toggleClass('active');
    });

    $('.contenttab-mobile .nav-link').off('click').on('click', function (e) {
        if (window.innerWidth > 768) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var targetId = $(this).attr('href');

        if (!targetId || targetId === '#') {
            return false;
        }

        var $target = $(targetId);

        if (!$target.length) {
            return false;
        }

        if ($target.hasClass('active')) {
            $target.removeClass('active show d-block');
            $(this).removeClass('active');
        } else {
            $('.pd-detail-tabs-container .tab-pane').removeClass('active show d-block');
            $('.contenttab-mobile .nav-link').removeClass('active');

            $target.addClass('active show d-block');
            $(this).addClass('active');
        }

        return false;
    });

    $('.mobile-accordion-title').off('click').on('click', function (e) {
        var targetId = $(this).data('target-id');
        if ($('#'+targetId).hasClass('d-block')) {
            $('#'+targetId).removeClass('d-block');
        } else {
            $('.product-detail-content').removeClass('d-block');
            $('#'+targetId).addClass('d-block');
        }
    });
});
